import { ErrorText } from "styles/text";
import { DoubleElimBracket } from "components/Bracket/DoubleElimBracket";
import { SingleElimBracket } from "components/Bracket/SingleElimBracket";
import { BracketGraph } from "model/Bracket/BracketGraph";
import { ShuffleBracketGraph } from "model/Bracket/ShuffleBracketGraph";
import { DoubleElimShuffleBracket } from "./Shuffle/DoubleElimShuffleBracket";
import { BracketMatchArgs } from "./BracketMatchArgs";
import { SingleElimShuffleBracket } from "./Shuffle/SingleElimShuffleBracket";
import { MultiLevelBracket } from "./Shuffle/MultiLevelBracket";
import { Bracket } from "model/Tournament/Segment/Bracket/Bracket";

interface Props {
  bracket: Bracket;
  tournamentId: string;
  compact: boolean; // todo - better solution for varied styling in different Bracket Match views
  bracketMatchArgs?: BracketMatchArgs;
}

export const BracketViewer = ({
  bracket,
  tournamentId,
  bracketMatchArgs,
  compact,
}: Props) => {
  return getBracket(bracket, compact, tournamentId, bracketMatchArgs);
};

const getBracket = (
  bracket: Bracket,
  compact: boolean,
  tournamentId: string,
  bracketMatchArgs: BracketMatchArgs | undefined
) => {
  if (!bracket.graph) {
    return <ErrorText>Unable to build bracket</ErrorText>;
  }

  if (bracket.bracketType === "SingleElim") {
    return (
      <SingleElimBracket
        bracketGraph={bracket.graph as BracketGraph}
        tournamentId={tournamentId}
        compact={compact}
        bracketMatchArgs={bracketMatchArgs}
      />
    );
  }

  if (bracket.bracketType === "DoubleElim") {
    return (
      <DoubleElimBracket
        bracketGraph={bracket.graph as BracketGraph}
        tournamentId={tournamentId}
        compact={compact}
        bracketMatchArgs={bracketMatchArgs}
      />
    );
  }

  if (bracket.bracketType === "SingleElimShuffle") {
    return (
      <SingleElimShuffleBracket
        bracketGraph={bracket.graph as ShuffleBracketGraph}
        tournamentId={tournamentId}
        bracketMatchArgs={bracketMatchArgs}
      />
    );
  }

  if (bracket.bracketType === "DoubleElimShuffle") {
    return (
      <DoubleElimShuffleBracket
        bracketGraph={bracket.graph as ShuffleBracketGraph}
        tournamentId={tournamentId}
        bracketMatchArgs={bracketMatchArgs}
      />
    );
  }

  if (bracket.bracketType === "Multilevel") {
    return (
      <MultiLevelBracket
        bracketGraph={bracket.graph as ShuffleBracketGraph}
        tournamentId={tournamentId}
        bracketMatchArgs={bracketMatchArgs}
      />
    );
  }

  return <ErrorText>Unknown Bracket Type</ErrorText>;
};
